const renderDaysActivity = (state, componentNode) => {
  const { days } = state;
  const dayNodes = Array.from(componentNode.querySelectorAll('.calendar-table__day'));

  dayNodes.forEach((dayNode) => {
    const currentDayDate = dayNode.dataset.calendarDate;
    const [day] = days.filter(({ date }) => date === currentDayDate);

    if (!day) {
      dayNode.classList.remove('_active');
      return;
    }

    dayNode.classList.add('_active');
  });
};

const renderDaysFocusing = (state, componentNode) => {
  const { days } = state;
  const dayNodes = Array.from(componentNode.querySelectorAll('.calendar-table__day'));

  dayNodes.forEach((dayNode) => {
    const currentDayDate = dayNode.dataset.calendarDate;
    const [day] = days.filter(({ date }) => date === currentDayDate);

    if (!day || day.focusingState !== 'focused') {
      dayNode.classList.remove('_focused');
      return;
    }

    dayNode.classList.add('_focused');
  });
};

const renderDaysFilling = (state, componentNode) => {
  const { days } = state;
  const dayNodes = Array.from(componentNode.querySelectorAll('.calendar-table__day'));

  dayNodes.forEach((dayNode) => {
    const currentDayDate = dayNode.dataset.calendarDate;
    const [day] = days.filter(({ date }) => date === currentDayDate);

    if (!day || day.fillingState !== 'filled') {
      dayNode.classList.remove('_filled');
      return;
    }

    dayNode.classList.add('_filled');
  });
};

const renderDayTime = (state, componentNode) => {
  const { days } = state;
  const dayNodes = Array.from(componentNode.querySelectorAll('.calendar-table__day'));

  dayNodes.forEach((dayNode) => {
    const dayContentNode = dayNode.querySelector('.calendar-table__day-list');
    const currentDayDate = dayNode.dataset.calendarDate;
    const [day] = days.filter(({ date }) => date === currentDayDate);

    if (!day || day.fillingState !== 'filled') {
      dayContentNode.innerHTML = '';
      return;
    }

    const { focusingState, timeFromValue, timeToValue } = day;

    if (focusingState !== 'focused') {
      return;
    }

    const timeString = `${timeFromValue} - ${timeToValue}`;

    dayContentNode.innerHTML = `<div class="calendar-table__day-event"><span>${timeString}</span></div>`;
  });
};

const renderTimeStage = (state, componentNode) => {
  const { days } = state;
  const timeStageNode = componentNode.querySelector('[data-schedule-calendar="time-stage"]');
  const timeFromNode = componentNode.querySelector('[data-schedule-calendar="time-from"]');
  const timeToNode = componentNode.querySelector('[data-schedule-calendar="time-to"]');
  const hasFocusedDays = (days.filter(({ focusingState }) => focusingState === 'focused')).length > 0;

  if (hasFocusedDays) {
    timeFromNode.value = state.timeFromValue;
    timeToNode.value = state.timeToValue;
    timeStageNode.classList.remove('_disabled');
    return;
  }

  timeFromNode.value = '';
  timeToNode.value = '';
  timeStageNode.classList.add('_disabled');
};

const renderTimeFields = (state, componentNode) => {
  const { timeFromValue, timeToValue } = state;

  const timeFromNode = componentNode.querySelector('[data-schedule-calendar="time-from"]');
  const timeToNode = componentNode.querySelector('[data-schedule-calendar="time-to"]');

  timeFromNode.value = timeFromValue;
  timeToNode.value = timeToValue;
};

const renderApplyButton = (state, componentNode) => {
  const { days } = state;
  const hasFilledDays = (days.filter(({ fillingState }) => fillingState === 'filled')).length > 0;
  const applyButtonNode = componentNode.querySelector('[data-schedule-calendar="apply-btn"]');

  applyButtonNode.disabled = !hasFilledDays;
};

const renderCancelButton = (state, componentNode) => {
  const { days } = state;
  const cancelButtonNode = componentNode.querySelector('[data-schedule-calendar="cancel-btn"]');
  const hasFilledDays = (days.filter(({ fillingState }) => fillingState === 'filled')).length > 0;

  cancelButtonNode.innerHTML = hasFilledDays
    ? '<span class="button__text">Сбросить</span>' : '<span class="button__text">Отменить</span>';
};

const renderTimeStageErrors = (state, componentNode) => {
  const { timeFormatValidity } = state;
  const timeStageNode = componentNode.querySelector('[data-schedule-calendar="time-stage"]');

  if (timeFormatValidity !== 'invalid') {
    timeStageNode.classList.remove('_invalid');
    return;
  }

  timeStageNode.classList.add('_invalid');
};

const renderWindowVisibility = (state, componentNode) => {
  const { windowVisibility } = state;

  if (windowVisibility !== 'shown') {
    componentNode.classList.remove('_window-shown');

    return;
  }

  componentNode.classList.add('_window-shown');
};

const renderResult = (resultData, componentNode) => {
  const {
    date,
    timeStart,
    timeEnd,
  } = resultData;

  const togglerTextNode = componentNode.querySelector('[data-schedule-calendar="toggler-text"]');
  const resultDateNode = componentNode.querySelector('[data-schedule-calendar="result-date"]');
  const resultTimeStartNode = componentNode.querySelector('[data-schedule-calendar="result-t-start"]');
  const resultTimeEndNode = componentNode.querySelector('[data-schedule-calendar="result-t-end"]');

  const hasResult = date.length > 0;

  if (!hasResult) {
    togglerTextNode.textContent = 'Выберите время и дату';
    resultDateNode.value = '';
    resultTimeStartNode.value = '';
    resultTimeEndNode.value = '';
    return;
  }

  togglerTextNode.textContent = 'Изменить время и дату';
  resultDateNode.value = date.join();
  resultTimeStartNode.value = timeStart.join();
  resultTimeEndNode.value = timeEnd.join();
};

export default {
  renderDaysActivity,
  renderDaysFocusing,
  renderDaysFilling,
  renderDayTime,
  renderTimeStage,
  renderTimeFields,
  renderApplyButton,
  renderCancelButton,
  renderTimeStageErrors,
  renderWindowVisibility,
  renderResult,
};
